import PropsTypes from "prop-types";

const adminExportOrderProps = {
  type: {
    isOpenModal: PropsTypes.bool.isRequired,
    setIsOpenModal: PropsTypes.func.isRequired,
  },
};

export default adminExportOrderProps;
